import API from 'services/API';

export default function getSubjects() {
  return API.request({
    method: 'GET',
    url: '/themes',
    mapper: (data) =>
      data
        .sort((d1, d2) => d1.orderBy - d2.orderBy)
        .map(function (data) {
          return {
            value: data.feedbackThemeId.toString(),
            label: data.name,
          };
        }),
  });
}
